var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container", staticStyle: { overflow: "hidden" } },
    [
      _c("div", { staticClass: "detail-header" }, [
        _c(
          "div",
          {
            staticClass: "header-left",
            staticStyle: {
              display: "flex",
              "justify-content": "space-between",
              "align-items": "center",
              width: "100%"
            }
          },
          [
            _c(
              "span",
              {
                staticStyle: {
                  "font-size": "16px",
                  "font-weight": "bold",
                  color: "#333"
                }
              },
              [
                _vm._v(
                  _vm._s(_vm.childData.areaName) +
                    " " +
                    _vm._s(
                      _vm.childData.areaName !== _vm.childData.areaGroupName
                        ? _vm.childData.areaGroupName
                        : ""
                    ) +
                    " " +
                    _vm._s(_vm.childData.buildingName) +
                    " " +
                    _vm._s(_vm.childData.unintName) +
                    " " +
                    _vm._s(_vm.childData.houseCode)
                )
              ]
            )
          ]
        )
      ]),
      _c(
        "div",
        { staticClass: "information" },
        [
          _c(
            "el-col",
            {
              staticStyle: { "margin-bottom": "10px", "padding-top": "5px" },
              attrs: { span: 24 }
            },
            [
              _c("div", { staticStyle: { "font-size": "16px" } }, [
                _vm._v("基础信息")
              ])
            ]
          ),
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: { "label-position": "right", "label-width": "130px" }
            },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.floorLocation") } },
                    [_c("span", [_vm._v(_vm._s(_vm.childData.floorName))])]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "排序" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.houseOrder))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.roomCode") } },
                    [_c("span", [_vm._v(_vm._s(_vm.childData.houseCode))])]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.roomType") } },
                    [_c("span", [_vm._v(_vm._s(_vm.childData.houseTypeName))])]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.buildArea") } },
                    [
                      _vm.childData.houseArea
                        ? _c("span", [_vm._v(_vm._s(_vm.childData.houseArea))])
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.useArea") } },
                    [
                      _vm.childData.houseUseArea
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.childData.houseUseArea))
                          ])
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: { "label-position": "right", "label-width": "130px" }
            },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.initialAcceptanceDate") } },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.childData.initialAcceptanceDate))
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.secondAcceptanceDate") } },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.childData.secondAcceptanceDate))
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.houseIsRentable") } },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.childData.houseIsRentableName))
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.memberRelationship") } },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.childData.memberRelationship))
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.roomState") } },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.childData.houseStatusName))
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.remark") } },
                    [_c("span", [_vm._v(_vm._s(_vm.childData.houseRemark))])]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { span: 24 }
                },
                [
                  _c("span", { staticStyle: { "font-size": "16px" } }, [
                    _vm._v("业主信息")
                  ])
                ]
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "业主信息" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.customerName))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "联系电话" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.userPhone))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "证件类型" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.userCardTypeName))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "证件号码" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.userCardSerno))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c("el-form-item", { attrs: { label: "家庭成员" } }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.childData.memberRelationship))
                    ])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { span: 24 }
                },
                [
                  _c("span", { staticStyle: { "font-size": "16px" } }, [
                    _vm._v("合同信息")
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "element-loading-text": "数据正在加载中...",
                border: "",
                stripe: "",
                fit: "",
                "highlight-current-row": ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: _vm.$t("table.id"), width: "50" }
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "合同编号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "link-type",
                            on: {
                              click: function($event) {
                                return _vm.handleContractDetail(
                                  scope.row.houseId
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(scope.row.houseCode))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "租户姓名" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "link-type",
                            on: {
                              click: function($event) {
                                return _vm.handleCustomerDetail(
                                  scope.row.houseId
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(scope.row.houseCode))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "合同起始日期" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.houseStatusName))])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "合同结束日期" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.houseStatusName))])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "合同状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.houseStatusName))])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogFormVisible,
            width: "920px",
            title: _vm.title
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c("house-add", {
            attrs: {
              "key-value": _vm.keyValue,
              "show-dialog": _vm.dialogFormVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogCustomerVisible,
            width: "920px",
            title: _vm.title
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogCustomerVisible = $event
            }
          }
        },
        [
          _c("house-custom", {
            attrs: {
              "key-value": _vm.keyValue,
              "show-dialog": _vm.dialogCustomerVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogHistoryVisible,
            width: "920px",
            title: _vm.title
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogHistoryVisible = $event
            }
          }
        },
        [
          _c("house-history", {
            attrs: {
              "key-value": _vm.keyValue,
              "show-dialog": _vm.dialogHistoryVisible
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }